import React from 'react'
import { Title, Column, Value } from '../shared.css'

interface PanelColumnProps {
  title: string | undefined
  value: string | undefined
}

const PanelColumn = ({ title, value }: PanelColumnProps) => (
  <Column>
    <Title>{title}</Title>
    <Value>{value}</Value>
  </Column>
)

export default PanelColumn
